import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { PaymentDtoLevelEnum } from 'api/generated';

import {
  confirmRestorePasswordThunk,
  getCustomerByEmailThunk,
  restorePasswordThunk,
  signInThunk,
  signUpByEmailThunk,
  signUpPromoThunk,
} from './actions';

interface AuthSlice {
  accessToken: null | string;
  isLandingPage: null | string;
  email: string;
  customerId: string | null;
  stripeCustomerId: string | null;
  isExistingCustomer: boolean;
  level: PaymentDtoLevelEnum | '';
}

const initialState: AuthSlice = {
  accessToken: '',
  isLandingPage: '',
  email: '',
  customerId: '',
  stripeCustomerId: '',
  isExistingCustomer: false,
  level: '',
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    signOut: (state) => ({ ...initialState, email: state.email }),
    setIsAuthenticated: (state, action: PayloadAction<string>) => ({
      ...state,
      accessToken: action.payload,
    }),
    setEmail: (state, action: PayloadAction<string>) => ({
      ...state,
      email: action.payload,
    }),
    setIsLandingPage: (state, action: PayloadAction<null | string>) => ({
      ...state,
      isLandingPage: action.payload,
    }),
  },
  extraReducers: (builder) => {
    builder
      .addCase(signInThunk.fulfilled, (state, { payload }) => {
        const { token } = payload;
        if (token) {
          state.accessToken = token;
        }
      })
      .addCase(restorePasswordThunk.fulfilled, (state, { payload }) => {
        const email = payload.customer?.email;
        if (email) {
          state.email = email;
        }
      })
      .addCase(signUpByEmailThunk.fulfilled, (state, { payload }) => {
        state.email = payload.customer.email;
        state.accessToken = payload.token;
      })
      .addCase(signUpPromoThunk.fulfilled, (state, { payload }) => {
        state.email = payload.customer.email;
        state.accessToken = payload.token;
      })
      .addCase(getCustomerByEmailThunk.fulfilled, (state, { payload }) => {
        state.customerId = payload.customerId;
        state.stripeCustomerId = payload.stripeCustomerId;
        state.isExistingCustomer = payload.isExistingCustomer;
      });
  },
});

export const actions = {
  ...authSlice.actions,
  signIn: signInThunk,
  restorePassword: restorePasswordThunk,
  confirmRestorePassword: confirmRestorePasswordThunk,
  signUpByEmail: signUpByEmailThunk,
  signUpPromo: signUpPromoThunk,
};

export const { reducer } = authSlice;
